import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function ScAnalysis() {
  const [data, setData] = useState([]); // Holds fetched data
  const [loading, setLoading] = useState(false); // Indicates loading state
  const [error, setError] = useState(null); // Error message
  const [fromDate, setFromDate] = useState(""); // Holds the selected date

  // Set today's date as the default
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setFromDate(formattedDate);
  }, []);

  // Fetch data from API
  const fetchData = async () => {
    if (!fromDate) {
      alert("Please select 'From' date.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://webcore.hunzagroupofindustries.com.pk/api/SCAnalysis?fDate=${fromDate}`
      );
      if (!response.ok) throw new Error("Failed to fetch data");
      const result = await response.json();
      setData(result);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="text-center mb-4 text-primary">Sugarcane Analysis</h3>

      {/* Date Selection Input */}
      <div className="row mb-4">
        <div className="col-md-4 offset-md-4">
          <label htmlFor="fromDate" className="form-label text-secondary">
            <strong>From Date:</strong>
          </label>
          <input
            type="date"
            id="fromDate"
            className="form-control border-primary"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 offset-md-4">
          <button
            className="btn btn-primary w-100 mt-3"
            onClick={fetchData}
            disabled={loading}
          >
            {loading ? "Loading..." : "Show Data"}
          </button>
        </div>
      </div>

      {/* Error Message */}
      {error && <div className="alert alert-danger mt-4 text-center">{error}</div>}

      {/* Data Table */}
      {data.length > 0 && (
        <div className="table-responsive mt-4">
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-light">
              <tr style={{ backgroundColor: "#f8f9fa", color: "#212529" }}>
                <th className="text-primary">Circle Name</th>
                <th className="text-success">Area Name</th>
                <th className="text-end text-danger">No of Samples</th>
                <th className="text-end text-success">Recovery</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#e9ecef" : "#fdfdfe",
                  }}
                >
                  <td>{item.CircleName || 0}</td>
                  <td>{item.AreaName}</td>
                  <td className="text-end">{item.NoOfSamples || 0}</td>
                  <td className="text-end">{((item.Recovery||=0))}</td>
                </tr>
              ))}
              <tr style={{ backgroundColor: "#d4edda" }}>
                <td></td>
                <td className="text-success">
                  <strong>Total</strong>
                </td>
                <td className="text-end text-danger">
                  <strong>
                    {data.reduce(
                      (acc, item) => acc + (item.NoOfSamples || 0),
                      0
                    )}
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* No Data Available */}
      {!loading && data.length === 0 && (
        <div className="alert alert-warning text-center mt-4">
          No data available for the selected date.
        </div>
      )}
    </div>
  );
}

export default ScAnalysis;
